export default __webpack_public_path__ + "static/media/Bold.38c5187d.woff2";